import { Typography } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { KeyAssessmentAcceleratorModuleAssignmentStatus } from 'types/schema-generated-types';

export enum Status {
  IN_PROGRESS = 'In Progress'
}

const statusColorMap: any = {
  [KeyAssessmentAcceleratorModuleAssignmentStatus.COMPLETED]: { bg: '#52A486', color: '#fff' },
  [KeyAssessmentAcceleratorModuleAssignmentStatus.ASSIGNED]: { bg: '#FFC210', color: '#000' },
  [Status.IN_PROGRESS]: { bg: '#54A3DA', color: '#fff' },
  [KeyAssessmentAcceleratorModuleAssignmentStatus.NOT_ASSIGNED]: { bg: '#D9D9D9', color: '#757575' }
};

type Props = {
  status: any;
  style?: React.CSSProperties;
};

const ModuleStatusChip: React.FC<Props> = ({ status, style }) => {
  const { t } = useTranslation(['Reports', 'ReportsHelpCommon', 'ReportsHelpTableColumns']);

  const labelMap: any = {
    [KeyAssessmentAcceleratorModuleAssignmentStatus.COMPLETED]: t('Completed'),
    [KeyAssessmentAcceleratorModuleAssignmentStatus.ASSIGNED]: t('Assigned'),
    [KeyAssessmentAcceleratorModuleAssignmentStatus.IN_PROGRESS]: t('In Progress'),
    [KeyAssessmentAcceleratorModuleAssignmentStatus.NOT_ASSIGNED]: t('Not Assigned')
  };

  return !status ? (
    <>-</>
  ) : (
    <Typography
      variant="body2"
      style={{
        maxHeight: 28,
        padding: '2px 4px',
        borderRadius: 2,
        backgroundColor: statusColorMap[status]?.bg ?? statusColorMap[Status.IN_PROGRESS].bg,
        color: statusColorMap[status]?.color ?? statusColorMap[Status.IN_PROGRESS].color,
        ...style
      }}
    >
      {labelMap[status]}
    </Typography>
  );
};

export default ModuleStatusChip;
